<template>
	<div>
		<!-- Banner Img -->
		<ConfirmDialog ref="dialog" />
		<v-img
			alt="chicken, yummy chicken, fried chicken, manok, yummy, farm, farms, chicken, https://www.pexels.com/photo/three-black-handset-toys-821754/ "
			class="bannerImg"
			src="@/assets/imgs/contact.jpg"
		>
			<div class="class">
				<h1 class="hello" style="font-size: 100px; color: rgba(0, 100, 0, 0.5)">Get In Touch</h1>

				<v-icon size="150" color="white">mdi-chevron-double-down</v-icon>
			</div>
		</v-img>

		<!-- Contact Form -->
		<v-container>
			<v-card outlined elevation="4" class="pa-6">
				<v-card-title> <strong> Contact Us </strong> </v-card-title>
				<v-spacer></v-spacer>
				<v-container>
					<v-form lazy-validation ref="form">
						<v-row>
							<v-col cols="12" lg="8" md="8" sm="8">
								<v-text-field
									outlined
									label="Full Name"
									v-model="name"
									:rules="[v => !!v || 'Item is required']"
								/>
								<v-text-field
									outlined
									label="Email"
									v-model="email"
									:rules="[v => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
								/>
								<v-text-field
									step="any"
									min="0"
									ref="input"
									outlined
									label="Mobile"
									v-model="mobile"
									@keypress="isNumber($event)"
									:rules="[
										val => {
											if (val < 0) return 'Please enter a positive number';
											return true;
										},
									]"
								/>
								<v-textarea
									no-resize
									outlined
									label="Message"
									v-model="message"
									:rules="[v => !!v || 'Item is required']"
								/>
								<v-row :justify="isMobile() ? `center` : `end`">
									<v-card-actions>
										<v-btn color="primary" outlined large @click="sendMessage()" :loading="sending">
											Send Message
										</v-btn>
									</v-card-actions>
								</v-row>
							</v-col>

							<!-- Details -->
							<v-col
								cols="12"
								lg="4"
								md="4"
								sm="4"
								:class="isMobile() ? `text-center mt-12` : `text-left`"
							>
								<div class="ml-4 mb-4" id="scroll">
									<strong> Address: </strong>
									14 Hands Road Middleton, Christchurch 8024
									<br />
									<br />
									<strong> Phone: </strong> 03 348 0086
								</div>

								<v-list>
									<v-list-item two-line>
										<v-list-item-content>
											<strong style="font-size: 31px"> Hours </strong>
											<v-list-item-title class="mt-2">
												<strong> Monday - Saturday </strong>
											</v-list-item-title>
											<v-list-item-subtitle> 10am - 3pm</v-list-item-subtitle>
											<!-- <v-list-item-title> <strong> Tuesday </strong> </v-list-item-title>
                      <v-list-item-subtitle> 10am - 3pm</v-list-item-subtitle>
                      <v-list-item-title> <strong> Wednesday </strong> </v-list-item-title>
                      <v-list-item-subtitle> 10am - 3pm</v-list-item-subtitle>
                      <v-list-item-title> <strong> Thursday </strong> </v-list-item-title>
                      <v-list-item-subtitle> 10am - 3pm</v-list-item-subtitle>
                      <v-list-item-title> <strong> Friday </strong> </v-list-item-title>
                      <v-list-item-subtitle> 10am - 3pm</v-list-item-subtitle>
                      <v-list-item-title> <strong> Saturday </strong> </v-list-item-title>
                      <v-list-item-subtitle> 10am - 3pm</v-list-item-subtitle> -->
											<v-list-item-title class="mt-3">
												<strong> Sunday </strong>
											</v-list-item-title>
											<v-list-item-subtitle> Closed </v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
			</v-card>
		</v-container>
	</div>
</template>

<script>
	import { API } from 'aws-amplify';
	import { sendContactEmail } from '@/graphql/mutations';
	import { load } from 'recaptcha-v3';
	import ConfirmDialog from '../../components/ConfirmDialog.vue';

	export default {
		components: {
			ConfirmDialog,
		},

		data: () => ({
			name: '',
			email: '',
			mobile: '',
			message: '',
			isSent: false,
			sending: false,
			recaptcha: null,
		}),

		async mounted() {
			this.recaptcha = await load('6LdnkfMiAAAAAFnPKm5ra1Hs1ytnRGj9d_tb9E-s');
		},

		methods: {
			isNumber(evt) {
				evt = evt ? evt : window.event;
				var charCode = evt.which ? evt.which : evt.keyCode;
				if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
					evt.preventDefault();
				} else {
					return true;
				}
			},
			isMobile() {
				if (this.$vuetify.breakpoint.width < 800) {
					return true;
				}
			},

			async sendMessage() {
				if (!this.$refs.form.validate() || this.recaptcha == null) return;
				// let loaded = await this.$recaptchaLoaded();
				// if (loaded) {
				this.sending = true;

				const token = await this.recaptcha.execute();

				this.sending = true;
				this.msg = '';
				// await this.$recaptcha().then(async (token) => {
				let emailTemplate = `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>Contact Us - Farms Chicken.</title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
                            body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
                            table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
                            img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
                            p { display:block;margin:13px 0; }</style><!--[if mso]>
                            <xml>
                            <o:OfficeDocumentSettings>
                            <o:AllowPNG/>
                            <o:PixelsPerInch>96</o:PixelsPerInch>
                            </o:OfficeDocumentSettings>
                            </xml>
                            <![endif]--><!--[if lte mso 11]>
                            <style type="text/css">
                            .mj-outlook-group-fix { width:100% !important; }
                            </style>
                            <![endif]--><style type="text/css">@media only screen and (min-width:480px) {
                            .mj-column-per-100 { width:100% !important; max-width: 100%; }
                            }</style><style type="text/css">@media only screen and (max-width:480px) {
                            table.mj-full-width-mobile { width: 100% !important; }
                            td.mj-full-width-mobile { width: auto !important; }
                            }</style></head><body style="background-color:white;"><div style="display:none;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">Query</div><div style="background-color:white;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#E7E7E7;background-color:#E7E7E7;width:100%;"><tbody><tr><td><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:200px;"><a href="https://www.farmschicken.co.nz" target="_blank"><img alt height="auto" src="https://www.farmschicken.co.nz/img/logo.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:40%;font-size:13px;" width="200"></a></td></tr></tbody></table></td></tr><tr><td align="center" style="font-size:0px;padding:10px 25px;padding-top:0;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:13px;font-weight:bold;letter-spacing:1px;line-height:20px;text-align:center;text-transform:uppercase;color:#105E30;"></div></td></tr><tr><td align="center" style="font-size:0px;padding:0;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:600px;"><img alt height="auto" src="https://scontent.fwlg1-2.fna.fbcdn.net/v/t39.30808-6/300566157_435809681901170_7202929623597783557_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=e3f864&_nc_ohc=DuKAYJX8eHEAX8kwHIH&_nc_ht=scontent.fwlg1-2.fna&oh=00_AfDDITM41V6sJRS9ksoBByCei7u5Z2c0II-NwzIE3hNuLw&oe=636FB92D" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600"></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="body-section-outlook" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div class="body-section" style="-webkit-box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); -moz-box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); margin: 0px auto; max-width: 600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0;padding-top:0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-left:15px;padding-right:15px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:570px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:20px;font-weight:bold;line-height:24px;text-align:left;color:#212b35;"></div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#637381;">Name: ${
															this.name
														}<br>Email: ${this.email}<br>Mobile: ${
					this.mobile
				}</div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:20px;font-weight:400;line-height:24px;text-align:left;color:#105E30;"><br><strong>Message</strong></div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="white-space: pre-wrap;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#637381;"> ${
					this.message
				} </div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div>
                            <br><br>
                            <center> Copyright ©  ${new Date(
															Date.now()
														).getFullYear()} <a style="text-decoration:none; color:#105E30;" href="https://www.farmschicken.co.nz">Farms Chicken.</a> All Rights Reserved. </p> </center>
                            </body></html>`;
				let body = {
					emailTo: ['info@farmschicken.co.nz'],
					replyTo: [this.email],
					emailFrom: 'Web | Farms Chicken <web-contact-noreply@farmschicken.co.nz>',
					emailHtmlBody: emailTemplate,
					emailSubject: 'Contact Us - Farms Chicken.',
					emailTextBody:
						'Please view this email in a updated browser to see more details.Thank You! Farms Chicken.',
					grecaptcharesponsetoken: token,
					site: 'farmschicken',
				};

				let res = await API.graphql({
					query: sendContactEmail,
					variables: {
						input: JSON.stringify(body),
					},
					authMode: 'API_KEY',
				});

				let challenge = JSON.parse(res.data.sendContactEmail);

				if (challenge.statusCode == 200) {
					let text = 'Thank you for communicating with us.';
					if ((await this.$refs.dialog.open('Message Sent!', text, { noconfirm: true })) == true) {
						this.$router.push('/');
					}
				} else {
					let text = 'There was a problem sending  your message. Please try again.';
					if ((await this.$refs.dialog.open('Error', text, { noconfirm: true })) == true) {
						location.reload();
					}
				}

				// let challenge = JSON.parse(res.data.sendContactEmail);

				// if (challenge.statusCode == 200) {
				//   alert("Message Sent!\r\n\r\nThank you for communicating with us.");
				//   this.$router.push("/");
				// } else {
				//   alert("There was a problem sending message. \r\n\r\nPlease Try Again.");
				//   location.reload();
				// }

				this.sending = false;
				// await apiClient.api
				//   .post("", body)
				//   .then(() => {
				//     this.sending = false;
				//     this.sent = true;
				//     this.msg =
				//       "YOUR MESSAGE WAS SENT, WE WILL GET BACK TO YOU AS SOON AS POSSIBLE";
				//   })
				//   .catch((e) => {
				//     this.sending = false;
				//     this.sent = false;
				//     this.error = true;
				//     this.msg = "AN ERROR OCCURED PLEASE TRY AGAIN";
				//     console.log(e);
				//   });

				this.name = '';
				this.mobile = '';
				this.email = '';
				this.message = '';
				this.sent = true;
				this.sending = false;
				// });
				// }
			},
		},
	};
</script>

<style>
	.class {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.hello {
		mix-blend-mode: multiply;
	}

	.bannerImg {
		background-position: center;
		background-attachment: fixed;
		max-height: 100vh;
	}
</style>
